export default function AlimRender({ children }) {
    let isAlim = process.env.REACT_APP_ALIM_USE === "Y";

    return <>{isAlim && children}</>;
};

export function isAlim(){
    let isAlim = process.env.REACT_APP_ALIM_USE === "Y";
    return isAlim;
}